export const sendGAEvent = (eventName, eventParams = {}) => {
	if (typeof window !== "undefined") {
		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ event: eventName, ...eventParams })
		//console.table("dataLayer:", window.dataLayer)
	}
}
